module.exports = __webpack_public_path__ + "img/vodun.3c5878dd.jpg";